<template>
  <b-card>
    <b-row>
      <b-col>
        <h3>{{ $route.name }}</h3>
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">{{ $t('dashboard') }}</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item
            ><router-link to="/attendance/">{{ $t('attendance') }}</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item>{{ name }}</b-breadcrumb-item>
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="border-bottom mb-3"></div>
        <div v-if="isLoading">
          <div class="text-center" style="margin: 3% auto;">
            <b-spinner small type="grow" label="Small Spinner"></b-spinner>
            <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
            <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
          </div>
        </div>
        <div class="mb-5" v-else>
            <b-row>
                <b-col>
                    <label for="" class="labels">nama pegawai</label>
                    <p class="text-bold">{{name}}</p>
                <label class="labels">Riwayat kehadiran</label>
                </b-col>

            </b-row>
          <paginated-table
            ref="dataTable"
            :can-show="true"
            :can-delete="false"
            :can-edit="false"
            :can-approve="false"
            :data-url="apiUrl.attendanceHistory"
            :can-reject="false"
            :data-key="dataKey"
            :data-columns="columns"
            :data-params="[]"
          >
          </paginated-table>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import PaginatedTable from '../../components/PaginatedTable.vue';

export default {
  components: { PaginatedTable },

  mounted() {
    this.getNamePegawai();
  },

  data() {
    return {
      isLoading: false,
      dataKey: 'attendance',
      name: "",
      apiUrl: {
        attendanceHistory:
          window.AppConfig.apiUrl + 'attendance' + '?user_uuid=' + this.$route.params.uuid,
      },
      columns: [
        {
          key: 'createdAt',
          label: this.$root.$t('date'),
        },
        {
          key: 'isOutstation',
          label: this.$root.$t('outStation'),
        },
        {
          key: 'clockInTime',
          label: this.$root.$t('clockin'),
        },
        {
          key: 'leave',
          label: this.$root.$t('leave'),
        },
        {
          key: 'breakInTime',
          label: this.$root.$t('startBreak'),
        },
        {
          key: 'breakOutTime',
          label: this.$root.$t('endBreak'),
        },
        {
          key: 'clockOutTime',
          label: this.$root.$t('clockout'),
        },
        {
          key: 'totalMinutesLate',
          label: this.$root.$t('totalLate'),
        },
      ],
    };
  },

  methods: {
    getNamePegawai() {
      this.$http
        .get(this.apiUrl.attendanceHistory)
        .then((res) => {
          this.name = res.data._embedded.attendance[0].userProfile;
          console.log(this.data);
        //   this.data.forEach((data) => {
        //     this.name.push({
        //         name: data.userProfile
        //     });
        //     // this.name.sort(a, b).name
        //   });
        //   console.log('nama:', this.name);
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
